const $ = require('jquery');
// const geolocation = require('./geolocation');
const geolocation = require('../../app/geolocation');
import get from 'lodash/get';

const apiWebroot = get(globals, 'apiWebroot', '/');

module.exports = {
  init() {
    // parāda papildus kritērijus meklēšanai
    $(document).on('change', '#additional_questions', function (e) {
      const aq_section = $(`#aq_${$(this).val()}`);
      const aq_answers = aq_section.find('.answers');
      aq_section.removeClass('is-hidden');
      aq_answers.removeClass('is-hidden');
      $('#additional_questions').trigger('questionadded', { height: aq_section.height() });
    });

    // aizvērt papildus kritērijus
    $(document).on('click', '.additionalQuestion-close', function (e) {
      e.preventDefault();
      const question = $(this).closest('.additionalQuestion');
      // paslēpj
      question.addClass('is-hidden');
      // iztīra visus checkbox
      question.find('input[type=checkbox]').prop('checked', false);
      $('#additional_questions').trigger('questionclosed', { height: question.height() });
    });

    // attiecīgās valsts pilsētu iegūšana no servera
    $(document).on('change', 'select#CountryId', () => {
      const countrySelect = $('select#CountryId');
      const citySelect = $('select#CityId');
      citySelect.val('—');
      const url = `${apiWebroot}questions/get_cities`;
      const post_data = {
        id: $('select#CountryId option:selected').val(),
      };
      $.post(url, post_data, (data) => {
        if ($.isEmptyObject(data)) {
          citySelect.parents().closest('.form-group').addClass('is-hidden');
        } else {
          citySelect.parents().closest('.form-group').removeClass('is-hidden');
          citySelect.empty();
          citySelect.append('<option value="0">—</option>');
          $.each(data, (x, y) => {
            citySelect.append(`<option value="${y.id}">${y.value} </option>`);
            citySelect.parent().find('ul').append(`<li data-value="${y.id}">${y.value} </li>`);
          });
        }
      });
      $('select#CountryId').trigger('countrychanged');
    });

    $('input#MembersProfileCityIdAutocomplete').cityAutocomplete({ input_id: '#MembersProfileCityId' });
    $(document).on('pjax:end', () => {
      $('input#MembersProfileCityIdAutocomplete').cityAutocomplete({ input_id: '#MembersProfileCityId' });
    });
    geolocation.init();
  },
};
